// ⚠️ ESTE IMPORT NO ES DECORATIVO: NADIE USA LO QUE IMPORTA, Y AUN ASI MANDA.
// `recoveryIntent` fotografia la URL en el momento en que se evalua. Lo importa
// ESTE archivo —y no un componente— porque `createClient(...)`, unas lineas mas
// abajo, arranca `_initialize()` de supabase-js, que borra el hash
// (`window.location.hash = ''`) y con el el `type=recovery` del enlace del correo.
// Al ser un import de este modulo, la foto queda tomada antes de esa llamada.
// Si alguien borra esta linea "porque no se usa", la recuperacion de contrasena
// vuelve a romperse EN SILENCIO: el usuario cae en el dashboard.
import './recoveryIntent';
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL  || '';
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// ── OBSERVABILIDAD DEL LATIDO DE REALTIME (no cambia la conducta) ────────────
// El 2026-08-11, en una pestana de larga duracion, las 10 subscriptions pasaron a CERO a la
// vez y el chat quedo sordo hasta un F5. La causa exacta no esta demostrada, y lo que faltaba
// para demostrarla era esto: saber que vio el cliente Realtime en ese instante.
//
// Este callback NO decide nada. No reconecta, no destruye, no re-suscribe: el ciclo de vida
// sigue siendo entero de la libreria. Solo anota los tres estados anomalos. `sent` y `ok` se
// ignoran (llegan cada 25 s y serian ruido puro).
const LATIDOS_ANOMALOS = ['error', 'timeout', 'disconnected'];

function observarLatido(status) {
  if (!LATIDOS_ANOMALOS.includes(status)) return;

  let connectionState = null;
  try {
    connectionState = supabase.realtime.connectionState();
  } catch (_) {
    // leer el estado nunca puede tumbar el latido
  }

  console.warn('feria-realtime-heartbeat', {
    ts: new Date().toISOString(),
    status,
    visibility: typeof document === 'undefined' ? null : document.visibilityState,
    connectionState,
  });
}

// Si no hay credenciales, el cliente existe pero todas las llamadas fallarán
// silenciosamente y el app usará los datos seed del contexto
export const supabase = createClient(
  SUPABASE_URL  || 'https://placeholder.supabase.co',
  SUPABASE_ANON || 'placeholder',
  { realtime: { heartbeatCallback: observarLatido } },
);

export const publicSupabase = createClient(
  SUPABASE_URL  || 'https://placeholder.supabase.co',
  SUPABASE_ANON || 'placeholder',
  {
    auth: {
      storageKey: 'feria-public-supabase-auth',
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
    },
  },
);

export const isConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON);
